package tta.destinigo.talktoastro.feature_authentication.domain

enum class CurrentScreen {
    LOGIN_USER,
    REGISTER_USER
}